export const APP_NAME = 'Juna';
export const APP_DESCRIPTION = 'Your AI-powered wedding planning assistant.';
